<template> 
   <v-container fluid fill-height pa-0 ma-0>
      <input v-if=false type="file" id="file" ref="file"/>
   <v-layout>      
    <v-card
        color="grey lighten-4"
        flat      
        width="100%"        
    >

    <v-toolbar color="#F5F5F5">             
      <v-select class="pr-3"        
         :items="dataset"
         v-model="selectedDataset"
         item-text="name"
         item-value="value"
         return-object
         v-on:change="onChangeDataset"
      ></v-select>              
      <v-select class="pr-3"
         ref="level"
         :items="level"
         v-model="selectedLevel"
         item-text="name"
         item-value="value"
         return-object
         v-on:change="onChangeLevel"
      ></v-select>   
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
            <v-btn 
               dark
               icon
               v-on="on"
               @click="showDataBtnClick">
            <v-icon class="decide-color-mc" dark>fas fa-table</v-icon>
            </v-btn>   
         </template>
         <span>{{ this.$t('showDataBtnText') }}</span>
      </v-tooltip>
      <download-excel         
         :fetch = "fetchData"         
         :fields = "json_fields"
         :before-generate = "startDownload"
         :before-finish = "finishDownload"         
         worksheet = "Data"
         name    = "data.xls">
         <v-tooltip bottom>
            <template v-slot:activator="{ on }">
               <v-btn         
                  dark
                  icon  
                  v-on="on"       
                  >
               <v-icon class="decide-color-mc" dark>fas fa-file-excel</v-icon>
               </v-btn> 
            </template>
            <span>{{ this.$t('saveAsTableBtnText') }}</span>
         </v-tooltip>        
      </download-excel> 
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
            <v-btn          
               dark
               icon
               v-on="on" 
               @click="downloadShapeFileBtnClick">
            <v-icon class="decide-color-mc" dark>fas fa-file-archive</v-icon>
            </v-btn>   
         </template>
         <span>{{ this.$t('saveAsShpBtnText') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
            <v-btn          
               dark
               icon
               v-on="on" 
               @click="downloadFileGDBBtnClick">
            <v-icon class="decide-color-mc" dark>fas fa-database</v-icon>
            </v-btn>   
         </template>
         <span>{{ this.$t('saveAsFileGeoBtnText') }}</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <!--
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
            <v-btn 
               dark
               icon 
               v-on="on" >
            <v-icon class="decide-color-mc" dark>fas fa-film</v-icon>
            </v-btn>  
         </template>
         <span>{{ this.$t('videoTutorialBtnText') }}</span>
      </v-tooltip>
      -->
      <!--
      <v-tooltip bottom>
         <template v-slot:activator="{ on }">
            <v-btn 
               dark
               icon 
               v-on="on"
               :href="selectedManual" target="_blank">
            <v-icon class="decide-color-mc" dark>far fa-file-alt</v-icon>
            </v-btn>     
         </template>
         <span>{{ this.$t('userManualBtnText') }}</span>
      </v-tooltip>
      --> 
    </v-toolbar> 
    
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{ this.$t('waitMsg') }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="message" hide-overlay persistent max-width="300">
       <v-card>
        <v-card-title class="headline">Information</v-card-title>
        <v-card-text>Please select at least one location to show/download data.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="message = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 

    <splitpanes class="default-theme">
         <v-card splitpanes-size="30" height="100%"
         style="max-height: 100%"
         class="scroll-y" >
            <v-sheet class="pa-0">     
               <v-text-field class="pl-4 pr-2"
               v-model="searchText"
               :label="searchVariableLabel"
               hide-details
               clearable
               clear-icon="mdi-close-circle-outline"
               @keyup="inputKeyUp('indicatorTree')"
               ></v-text-field>
            </v-sheet>
            <v-card-text>            
               <v-jstree ref="indicatorTree" :data="indicatorTreeData" :text-field-name="selectedLanguage" show-checkbox multiple no-dots allow-batch whole-row></v-jstree>    
            </v-card-text> 
        </v-card>
        <v-card splitpanes-size="15" height="100%"
        style="max-height: 100%"
        class="scroll-y" >  
           <v-sheet class="pa-0">  
               <v-text-field class="pr-2"
               v-model="searchText"
               :label="searchLocationLabel"
               hide-details
               clearable
               clear-icon="mdi-close-circle-outline"
               @keyup="inputKeyUp('locationTree')"
               ></v-text-field>
            </v-sheet>           
            <v-card-text>
               <v-jstree ref="locationTree" :data="locationTreeData" :text-field-name="selectedLanguage" show-checkbox multiple no-dots allow-batch whole-row></v-jstree>    
            </v-card-text>  
        </v-card>        
        <v-card splitpanes-size="55" height="100%"
        style="max-height: 100%"
        class="scroll-y" >                          
         <v-data-table ref="featureTable"
            :headers="headers"
            :items="censusData"    
            :pagination.sync="pagination"        
            class="elevation-1"            
            style="height: 100%"
            hide-headers
            hide-actions            
            no-data-text=''
         >
            <template v-slot:items="props">
               <td v-for="(header, index) in headers"
               :key="index">
               {{ props.item[header.value] }}
               </td>               
            </template>  
            <template v-slot:footer>
               <td :colspan="headers.length">               
               </td>
            </template>          
         </v-data-table>          
      </v-card>   
    </splitpanes>
    </v-card> 
   </v-layout>
   </v-container>        
</template>

<script>
  // import VTreeview from './vtreeview'
  import VJstree from 'vue-jstree'
  import { loadModules } from 'esri-loader'
  import axios from 'axios'
  import Splitpanes from 'splitpanes'
  import 'splitpanes/dist/splitpanes.css'
  import downloadExcel from 'vue-json-excel'
  import indicatorPopCensus2005District from '../data/census2005_indicator_dist.json'
  import locationCensus2005 from '../data/census2005_location.json'

  const options = { version: '3.28', css: true};    

  export default {
   components: {
      VJstree,
      Splitpanes,
      downloadExcel
   },
   data () { 
      return { 
      dialog: false, 
      message: false,    
      searchText: '',
      searchVariableLabel: this.$t('searchVariableText'),
      searchLocationLabel: this.$t('searchLocationText'),
      indicatorList: null,
      locationList: null, 
      selectedDataset: {name: this.$t('dataset.census2005'), value: 'census2005'},
      selectedLevel: {name: this.$t('adminLevel.district'), value: 'District'},
      serviceUrl: "https://gis.cde.unibe.ch/gis/rest/services/Hosted/census2005_district/FeatureServer/0",
      dataset: [
         { name: this.$t('dataset.census2005'), value: 'census2005'},
         { name: this.$t('dataset.census2015'), value: 'census2015'},
         { name: this.$t('dataset.census2011'), value: 'census2011'}
      ], 
      level: [
         {name: this.$t('adminLevel.village'), value: 'Village'},         
         {name: this.$t('adminLevel.district'), value: 'District'}
      ],
      indicatorTreeData: indicatorPopCensus2005District,
      locationTreeData: locationCensus2005,
      headers:  [{text: 'Title', value: 'text'}],
      censusData: [{text: this.$t('welcomeText1')}, {text: this.$t('welcomeText2')}],
      pagination: {rowsPerPage: -1, sortBy: 'did'},
      json_fields: null,
      json_data: [],           
      json_meta: [
         [
            {
               'key': 'charset',
               'value': 'utf-8'
            }
         ]
      ]     
   }},
   computed: {
      selectedLanguage: function(){
         if (this.$i18n.locale === 'en') return 'name';
         else return 'name_lo';
      },
      selectedManual: function (){
         if (this.$i18n.locale === 'en') return 'data/Laos_k4d_manual_en.pdf';
         else return 'data/Laos_k4d_manual_lo.pdf';
      }      
   }, 
   methods: {
      selectedLocationFieldName: function(){
         if (this.selectedDataset.value === 'census2005') return 'did';
         else if (this.selectedDataset.value === 'census2015') {
            if (this.selectedLevel.value === 'Village') return 'usid';
            else if (this.selectedLevel.value === 'District') return 'ssid';
         }
         else return 'tid'; 
      },         
      onChangeLevel() {
         if (this.selectedDataset.value === 'census2005') {            
            switch(this.selectedLevel.value) {
               case 'Village':
                  axios.all([
                     axios.get('data/census2005_indicator_vill.json'),
                     axios.get('data/census2005_location.json'),
                  ])
                  .then(axios.spread((res1, res2) => {
                     this.loadTrees(res1.data, res2.data);
                  }));                                                       
                  this.serviceUrl = "https://gis.cde.unibe.ch/gis/rest/services/Hosted/census2005_village/FeatureServer/0"; 
                  break;
               case 'District':
                  axios.all([
                     axios.get('data/census2005_indicator_dist.json'),
                     axios.get('data/census2005_location.json'),
                  ])
                  .then(axios.spread((res1, res2) => {
                     this.loadTrees(res1.data, res2.data);
                  }));                                                      
                  this.serviceUrl = "https://gis.cde.unibe.ch/gis/rest/services/Hosted/census2005_district/FeatureServer/0";
                  break;
               default:
                  // code block
            }           
         }
         else if (this.selectedDataset.value === 'census2015') {
            switch(this.selectedLevel.value) {
               case 'Village':    
                  axios.all([
                     axios.get('data/census2015_indicator_vill.json'),
                     axios.get('data/census2015_location.json'),
                  ])
                  .then(axios.spread((res1, res2) => {
                     this.loadTrees(res1.data, res2.data);
                  }));                                                       
                  this.serviceUrl = "https://gis.cde.unibe.ch/gis/rest/services/Hosted/census2015_village/FeatureServer/0"; 
                  break;
               case 'District':
                  axios.all([
                     axios.get('data/census2015_indicator_dist.json'),
                     axios.get('data/census2015_location.json'),
                  ])
                  .then(axios.spread((res1, res2) => {
                     this.loadTrees(res1.data, res2.data);
                  }));                                                      
                  this.serviceUrl = "https://gis.cde.unibe.ch/gis/rest/services/Hosted/census2015_district/FeatureServer/0";
                  break;
            // case 'Kumban':
            //   break;
               default:
                  // code block
            }
         }
         else {
            switch(this.selectedLevel.value) {
               case 'Village':    
                  axios.all([
                     axios.get('data/census2011_indicator_vill.json'),
                     axios.get('data/census2011_location.json'),
                  ])
                  .then(axios.spread((res1, res2) => {
                     this.loadTrees(res1.data, res2.data);
                  }));                                                       
                  this.serviceUrl = "https://gis.cde.unibe.ch/gis/rest/services/Decide/census2011_village/MapServer/0"; 
                  break;               
               default:
                  // code block
            }
         }
      },
      onChangeDataset() {
         if (this.selectedDataset.value === 'census2005') { 
            this.level =  [
               {name: this.$t('adminLevel.village'), value: 'Village'},               
               {name: this.$t('adminLevel.district'), value: 'District'}
            ];                
            this.selectedLevel = {name: this.$t('adminLevel.district'), value: 'District'}; 
            this.onChangeLevel();                
         }
         else if (this.selectedDataset.value === 'census2015') {
            this.level =  [
               {name: this.$t('adminLevel.village'), value: 'Village'},
            // {name: 'Kumban', value: 'Kumban'},
               {name: this.$t('adminLevel.district'), value: 'District'}
            ];            
            this.selectedLevel = {name: this.$t('adminLevel.village'), value: 'Village'}; 
            this.onChangeLevel(); 
         } 
         else {
            this.level =  [
               {name: this.$t('adminLevel.village'), value: 'Village'}               
            ];            
            this.selectedLevel = {name: this.$t('adminLevel.village'), value: 'Village'}; 
            this.onChangeLevel(); 
         }           
      },
      inputKeyUp: function (treeRefStr) {         
         var text = this.searchText;
         const patt = new RegExp(text.toLowerCase());
         if (treeRefStr === "indicatorTree") {
            this.$refs.indicatorTree.handleRecursionNodeChilds(this.$refs.indicatorTree, function (node) {
               if (text !== '' && node.model !== undefined) {
                  const str = node.model.name.toLowerCase();
                  const str_lo = node.model.name_lo.toLowerCase();
                  if (patt.test(str) || patt.test(str_lo)) {
                     node.$el.querySelector('.tree-anchor').style.color = 'red'
                  } else {
                     node.$el.querySelector('.tree-anchor').style.color = '#000'
                  } // or other operations
               } else {
                  node.$el.querySelector('.tree-anchor').style.color = '#000'
               }
            });
         }
         else {
            this.$refs.locationTree.handleRecursionNodeChilds(this.$refs.locationTree, function (node) {
               if (text !== '' && node.model !== undefined) {
                  const str = node.model.name.toLowerCase();
                  const str_lo = node.model.name_lo.toLowerCase();
                  if (patt.test(str) || patt.test(str_lo)) {
                     node.$el.querySelector('.tree-anchor').style.color = 'red'
                  } else {
                     node.$el.querySelector('.tree-anchor').style.color = '#000'
                  } // or other operations
               } else {
                  node.$el.querySelector('.tree-anchor').style.color = '#000'
               }
            });
         }         
      },
      loadTrees (indicatorData, locationData) {
         this.indicatorTreeData = indicatorData; 
         this.locationTreeData = locationData;

         this.$refs.indicatorTree.initializeData(this.indicatorTreeData); // initialize the indicator tree with updated data
         this.$refs.locationTree.initializeData(this.locationTreeData); // initialize the location tree with updated data
         
         this.$refs.indicatorTree.data = this.indicatorTreeData; // needs to assign to the 'data' prop directly as assigning only to the binding-data did not affect its 'data'
         this.$refs.locationTree.data =  this.locationTreeData; // as a result, Vue warning is shown in the console                                   
      },
      async fetchData(){
         this.locationList = getSelectedLocations(this.locationTreeData);
         this.indicatorList = getSelectedIndicators(this.indicatorTreeData);
         var fieldInfos = getFieldInfos(this.indicatorTreeData);
         var serviceUrl = this.serviceUrl;          
         
         getFeatures(this, serviceUrl, fieldInfos); // call Query (async) task
         await new Promise((resolve, reject) => setTimeout(resolve, 5000)); // wait for 5s to populate the download data with the returned Query data
         if (this.json_data.length === 0) { 
            this.dialog = false; // if no location selection is made, close the progress dialog
            this.message = true; // show the information dialog to the user
         }    
         return this.json_data; // returning the data to the excel plugin for download only after 5s timeout     
      },
      startDownload(){                      
         this.dialog = true;         
      },
      finishDownload(){
         this.dialog = false;
      },
      showDataBtnClick () {
         this.locationList = getSelectedLocations(this.locationTreeData);
         this.indicatorList = getSelectedIndicators(this.indicatorTreeData);
         var fieldInfos = getFieldInfos(this.indicatorTreeData);
         var serviceUrl = this.serviceUrl;         
         if (this.locationList.length === 0) { 
            this.message = true; // show the information dialog to the user
         }
         else {
            showFeatureTable(this, serviceUrl, fieldInfos);
         }                    
      },
      downloadShapeFileBtnClick () {         
         this.locationList = getSelectedLocations(this.locationTreeData);
         this.indicatorList = getSelectedIndicators(this.indicatorTreeData);
         var fieldInfos = getFieldInfos(this.indicatorTreeData);
         var serviceUrl = this.serviceUrl; 
         var gpServiceUrl = 'https://gis.cde.unibe.ch/gis/rest/services/GPServices/Json2Shape/GPServer/Json2Shape';
         var gpFileUploadUrl = 'https://gis.cde.unibe.ch/gis/rest/services/GPServices/Json2Shape/GPServer/uploads/upload';
         if (this.locationList.length === 0) { 
            this.dialog = false; // if no location selection is made, close the progress dialog
            this.message = true; // show the information dialog to the user
         }
         else {
            this.dialog = true; // show the progress dialog         
            downloadSpatialData(this, serviceUrl, fieldInfos, gpServiceUrl, gpFileUploadUrl); // call Query (async) task
         }          
      },
      downloadFileGDBBtnClick () {         
         this.locationList = getSelectedLocations(this.locationTreeData);
         this.indicatorList = getSelectedIndicators(this.indicatorTreeData);
         var fieldInfos = getFieldInfos(this.indicatorTreeData);
         var serviceUrl = this.serviceUrl; 
         var gpServiceUrl = 'https://gis.cde.unibe.ch/gis/rest/services/GPServices/Json2Gdb/GPServer/Json2Gdb';
         var gpFileUploadUrl = 'https://gis.cde.unibe.ch/gis/rest/services/GPServices/Json2Gdb/GPServer/uploads/upload';
         if (this.locationList.length === 0) { 
            this.dialog = false; // if no location selection is made, close the progress dialog
            this.message = true; // show the information dialog to the user
         }
         else {
            this.dialog = true; // show the progress dialog         
            downloadSpatialData(this, serviceUrl, fieldInfos, gpServiceUrl, gpFileUploadUrl); // call Query (async) task
         }          
      },
      setDataTable(headers, censusData){
         this.headers = headers;
         this.censusData = censusData;         
      }
   }  
  }

   // Retrieve the checked locations from the Location Tree
   function getSelectedLocations(locationData) {      
      var locations = [];
      for(var i = 0; i < locationData.length; i++){
         for(var j = 0; j < locationData[i].children.length; j++){
            if (locationData[i].children[j].selected === true)
               locations.push(locationData[i].children[j].id);
         }            
      }

      if (locations.length === 0) {
         // return all locations by default
         for(var i = 0; i < locationData.length; i++){
            for(var j = 0; j < locationData[i].children.length; j++){               
               locations.push(locationData[i].children[j].id);
            }            
         }
      }
      
      return locations;
   }

    // Retrieve the checked indicators from the Indicators Tree
   function getSelectedIndicators(indicatorData){     
      var tempList = [];      
      indicatorData.forEach(function(item) {
         item.children.forEach(function(element){                        
            if (element.children.length != 0){
               element.children.forEach(function (subelement) {
                  if (subelement.children.length != 0) {
                     subelement.children.forEach(function(indicator) {
                        if (indicator.selected === true) {
                           tempList.push(indicator.id);
                        }
                     })                        
                  }
                  else {
                     if (subelement.selected === true) {
                        tempList.push(subelement.id);
                     }
                  }                        
               })                                    
            }
            else {
               if (element.selected === true) {
                  tempList.push(element.id);
               }                            
            }								
         })                    
      });
      return tempList;
   }

   // Populate the fieldInfos array for the column names mapping
   function getFieldInfos(data){
      var fieldInfos = [];      
      data.forEach(function(item) {
         item.children.forEach(function(element) {
            if (element.children.length != 0) {
               element.children.forEach(function (subelement) {
                  if (subelement.children.length != 0) {
                     subelement.children.forEach(function (indicator) {
                        fieldInfos.push({
                           "name": indicator.id,
                           "shortLabel": indicator.short_id,
                           "alias": indicator.name,
                           "alias_lo": indicator.name_lo,
                           "description": indicator.description,
                           "description_lo": indicator.description_lo,
                           "source": indicator.source,
                           "owner": indicator.owner
                        });
                     });
                  } else {
                     fieldInfos.push({
                        "name": subelement.id,
                        "shortLabel": subelement.short_id,
                        "alias": subelement.name,
                        "alias_lo": subelement.name_lo,
                        "description": subelement.description,
                        "description_lo": subelement.description_lo,
                        "source": subelement.source,
                        "owner": subelement.owner
                     });
                  }                              
               })  
            } else {
                  fieldInfos.push({
                     "name": element.id,
                     "shortLabel": element.short_id,
                     "alias": element.name,
                     "alias_lo": element.name_lo,
                     "description": element.description,
                     "description_lo": element.description_lo,
                     "source": element.source,
                     "owner": element.owner
                  });
            }
         })
      });   
      return fieldInfos;
   }

   // load required ESRI modules and initiate the Feature Layer/Table to show the query result
   function showFeatureTable(self,serviceUrl,fieldInfos) {
      loadModules([         
         "esri/tasks/query",
         "esri/tasks/QueryTask"
      ], options)
      .then(([        
         Query,
         QueryTask
      ]) => {
         // Build the query string based on the checked locations                  
         var query = '';
         var fieldName = self.selectedLocationFieldName();
         for (var i = 0; i < self.locationList.length; i++) {
               query = query + fieldName + " = " + self.locationList[i] + " OR ";
         }
         query = query.substring(0, query.length - 4); // remove the last OR from the query string

         var queryTask = new QueryTask(serviceUrl);
         var queryStr = new Query();
         queryStr.where = query;
         queryStr.returnGeometry = false;
         queryStr.outFields = self.indicatorList;
         if (serviceUrl.indexOf('FeatureServer') > 0) queryStr.num = 1000; // exclude the returned result count parameter for Map Services so that the correct count is returned
         
         queryTask.executeForCount(queryStr).then(function(count) { 
            var offset = 0;
            var queries = [];
            queryStr.num = 1000;

            for (var r = 0; r <= Math.floor(count/1000); r++) {  
               queryStr.start = offset;  
               queries.push(queryTask.execute(queryStr));  
               offset = offset + 1000; 
            }  

            Promise.all(queries).then(function(responses) {
               var results = responses[0];
               for (var j = 1; j < responses.length; j++) {
                  results.features = results.features.concat(responses[j].features);
               }

               var resultItems = [];
               var fieldItems = [];
               var resultCount = results.features.length;
               var fieldCount = results.fields.length;

               for (var i = 0; i < resultCount; i++) {
                  var featureAttributes = results.features[i].attributes;
                  var obj = {};
                  for (var attr in featureAttributes) { 
                     obj[attr] = featureAttributes[attr];                                  
                  }
                  resultItems.push(obj);
               }
               
               for (var i = 0; i < fieldCount; i++) {
                  var field = results.fields[i];     
                  if (self.$i18n.locale === 'en') var alias = fieldInfos.find(item => item.name === field.name).alias;    
                  else var alias = fieldInfos.find(item => item.name === field.name).alias_lo;                       
                  fieldItems.push({
                     text: alias,
                     value: field.name
                  });  
               }

               self.censusData = resultItems; // this alone doesn't work to refresh the table view
               self.headers = fieldItems; // this alone doesn't work to refresh the table view

               // TODO: avoid using props directly
               self.$refs.featureTable.headers = fieldItems;
               self.$refs.featureTable.items = resultItems;  
               self.$refs.featureTable.hideHeaders = false; 
            }); 
         });
      })
      .catch(err => {
         // handle any script or module loading errors
         console.log(err);
      });         
   }

   // load required ESRI modules and assign query results to variables needed for download
   function getFeatures(self,serviceUrl,fieldInfos) {     
      loadModules([         
         "esri/tasks/query",
         "esri/tasks/QueryTask"
      ], options)
      .then(([        
         Query,
         QueryTask
      ]) => {        
         // Build the query string based on the checked locations                  
         var query = '';
         var fieldName = self.selectedLocationFieldName();
         for (var i = 0; i < self.locationList.length; i++) {
               query = query + fieldName + " = " + self.locationList[i] + " OR ";
         }
         query = query.substring(0, query.length - 4); // remove the last OR from the query string

         var queryTask = new QueryTask(serviceUrl);
         var queryStr = new Query();
         queryStr.where = query;
         queryStr.returnGeometry = false;
         queryStr.outFields = self.indicatorList;
         if (serviceUrl.indexOf('FeatureServer') > 0) queryStr.num = 1000; // exclude the returned result count parameter for Map Services so that the correct count is returned
                  
         queryTask.executeForCount(queryStr).then(function(count) { 
            var offset = 0;
            var queries = [];
            queryStr.num = 1000;

            for (var r = 0; r <= Math.floor(count/1000); r++) {  
               queryStr.start = offset;  
               queries.push(queryTask.execute(queryStr));  
               offset = offset + 1000; 
            }  

            Promise.all(queries).then(function(responses) {
               var results = responses[0];
               for (var j = 1; j < responses.length; j++) {
                  results.features = results.features.concat(responses[j].features);
               }

               var resultItems = [];
               var resultCount = results.features.length;
               var fieldCount = results.fields.length;
               var json_fields = {};

               for (var i = 0; i < resultCount; i++) {
                  var featureAttributes = results.features[i].attributes;
                  var obj = {};
                  for (var attr in featureAttributes) { 
                     obj[attr] = featureAttributes[attr];                                  
                  }
                  resultItems.push(obj);
               }
               
               for (var i = 0; i < fieldCount; i++) {
                  var field = results.fields[i];    
                  if (self.$i18n.locale === 'en') var alias = fieldInfos.find(item => item.name === field.name).alias;    
                  else var alias = fieldInfos.find(item => item.name === field.name).alias_lo;    
                  json_fields[alias] = field.name;
               }

               // update to download data
               self.json_fields = json_fields;           
               self.json_data = resultItems;
            });
         });                         
      })
      .catch(err => {
         // handle any script or module loading errors
         console.log(err);
      });
   }

   function downloadSpatialData(self,serviceUrl,fieldInfos, gpServiceUrl, gpFileUploadUrl) {     
      loadModules([         
         "esri/tasks/query",
         "esri/tasks/QueryTask",
         "esri/tasks/Geoprocessor",
         "esri/request",
         "esri/tasks/DataFile"
      ], options)
      .then(([        
         Query,
         QueryTask,
         Geoprocessor,
         DataFile
      ]) => {        
         // Build the query string based on the checked locations                  
         var query = '';
         var fieldName = self.selectedLocationFieldName();
         for (var i = 0; i < self.locationList.length; i++) {
               query = query + fieldName + " = " + self.locationList[i] + " OR ";
         }
         query = query.substring(0, query.length - 4); // remove the last OR from the query string

         var queryTask = new QueryTask(serviceUrl);
         var queryStr = new Query();
         queryStr.where = query;
         queryStr.returnGeometry = true;
         queryStr.outFields = self.indicatorList;
         if (serviceUrl.indexOf('FeatureServer') > 0) queryStr.num = 1000; // exclude the returned result count parameter for Map Services so that the correct count is returned
                  
         queryTask.executeForCount(queryStr).then(function(count) { 
            var offset = 0;
            var queries = [];
            queryStr.num = 1000;

            for (var r = 0; r <= Math.floor(count/1000); r++) {  
               queryStr.start = offset;  
               queries.push(queryTask.execute(queryStr));  
               offset = offset + 1000; 
            }  

            Promise.all(queries).then(function(responses) {
               var results = responses[0];
               for (var j = 1; j < responses.length; j++) {
                  results.features = results.features.concat(responses[j].features);
               }
               
               // perform field alias names mapping for EN/LO versions           
               var fieldCount = results.fields.length;
               for (var i = 0; i < fieldCount; i++) {
                  var field = results.fields[i];
                  if (self.$i18n.locale === 'en') {
                     results.fields[i].shortLabel = fieldInfos.find(item => item.name === field.name).shortLabel;
                     results.fields[i].alias = fieldInfos.find(item => item.name === field.name).alias;
                     results.fields[i].description = fieldInfos.find(item => item.name === field.name).description;
                     results.fields[i].alias2 = fieldInfos.find(item => item.name === field.name).alias_lo;
                     results.fields[i].description2 = fieldInfos.find(item => item.name === field.name).description_lo;
                     results.fields[i].source = fieldInfos.find(item => item.name === field.name).source;
                     results.fields[i].owner = fieldInfos.find(item => item.name === field.name).owner;
                  } else {
                     results.fields[i].shortLabel = fieldInfos.find(item => item.name === field.name).shortLabel;
                     results.fields[i].alias = fieldInfos.find(item => item.name === field.name).alias_lo;
                     results.fields[i].description = fieldInfos.find(item => item.name === field.name).description_lo;
                     results.fields[i].alias2 = fieldInfos.find(item => item.name === field.name).alias;
                     results.fields[i].description2 = fieldInfos.find(item => item.name === field.name).description;
                     results.fields[i].source = fieldInfos.find(item => item.name === field.name).source;
                     results.fields[i].owner = fieldInfos.find(item => item.name === field.name).owner;
                  }
               }

               if (self.$i18n.locale === 'en') results.nls = 'en';
               else results.nls = 'lo';

               results.codeTxt = 'Code / ລະຫັດ';
               results.shortLabelTxt = 'Short label / ຊື່ຕົວຊິ້ວັດ';
               results.labelEnTxt = 'Label English / ຄວາມໝາຍ ອັງກິດ';
               results.labelLaoTxt = 'Label Lao / ຄວາມໝາຍ ລາວ';
               results.descriptionEnTxt = 'Description English / ຄຳອະທິບາຍ ອັງກິດ';
               results.descriptionLaoTxt = 'Description Lao / ຄຳອະທິບາຍ ລາວ';
               results.sourceTxt = 'Source / ແຫຼ່ງຂໍ້ມູນ';
               results.ownerTxt = 'Data owner / ເຈົ້າຂອງຂໍ້ມູນ';

               var str = JSON.stringify(results);
               var blob = new Blob([str], {
                  type: 'text/plain;charset=utf-8'
               });
               var formData = new FormData();
               formData.append("file", blob, "data.json");
               formData.set("f", "pjson");

               var gp = new Geoprocessor(gpServiceUrl);

               axios.post(gpFileUploadUrl,
                     formData, {
                           headers: {
                              'Content-Type': 'multipart/form-data'
                           }
                     }
                  ).then(function(response) {
                     var itemID = response.data.item.itemID;
                     var dataFile = new esri.tasks.DataFile();
                     dataFile.itemID = itemID;
                     var params = {
                           "json_file": dataFile
                     };
                     gp.execute(params, function(results, messages) {
                           const link = document.createElement('a');
                           link.href = results[0].value.url;
                           document.body.appendChild(link);
                           link.click();
                           self.dialog = false;
                     });
                  })
                  .catch(function(error) {
                     console.log(error);
                     self.dialog = false;
                  });
            });                                 
         });                
      })
      .catch(err => {
         // handle any script or module loading errors
         console.log(err);
      });
   }
   
</script>

<style>
   .scroll {
      overflow-y: auto;      
   }
   
   .decide-color-mc {
      color: #346cb6  !important;
   }
</style>